import MgrApi from '../interceptors/MgrApi';
import MGRPrivate from '../interceptors/MgrPrivate';
import MGRPublic from '../interceptors/MgrPublic';
import MgrTokenPublic from '../interceptors/MgrTokenPublic';

export const sessionsCreate = (data) => MGRPrivate.post('/auth/sessions', data);

export const sessionsCreateWithToken = (data, token) => MgrTokenPublic.post('/sessions', data, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const preSessionsCreate = (params) => MGRPrivate.get('/auth/sessions', { params });

export const verifyToken = async (data) => MGRPrivate.post('/auth/sessions/verification-code', data);

export const sessionsChangeClientId = (clientId) => MGRPrivate.patch(`/auth/sessions/${clientId}`);

export const sessionsDestroy = () => MGRPrivate.delete('/auth/sessions');

export const sessionsCheck = () => MgrApi.get('/sessions/check');

export const sessionTraduction = (lang = 'en') => MGRPublic.get(`https://resources.datanomik.com/widget/i18n/${lang}.json`);

export const reportTraduction = (lang = 'en') => MGRPublic.get(`https://resources.datanomik.com/reports/i18n/${lang}.json`);
